$(document).ready(function() {
    $(document).on('click', '.js-auth', function() {
        if (!($('.b-header').hasClass('menu'))) {
            $('body').toggleClass('is-modal-open');
        }
        $('.b-header').toggleClass('modal');
        if ($('.b-modal').is(":visible")) {
            $('.b-modal').hide();
        } else {
            $('.b-modal--auth').show();
        }
    });

    $(document).on('click', '.js-exit', function(e) {
        if ($(window).width() < 1024) {
            e.preventDefault();
            if (!($('.b-header').hasClass('menu'))) {
                $('body').toggleClass('is-modal-open');
            }
            $('.b-header').toggleClass('modal');
            if ($('.b-modal').is(":visible")) {
                $('.b-modal').hide();
            } else {
                $('.b-modal--exit').show();
            }
        }
    });

    $(document).on('click', '.js-auth-link', function() {
    	$('.b-modal--auth').hide();
    	$('.b-modal--reg').show();
    });
    $(document).on('click', '.js-reg-link', function() {
    	$('.b-modal--reg').hide();
    	$('.b-modal--auth').show();
    });

    $(document).on('keyup', '.js-email', function() {
        if ($(this).val().indexOf('@') > 0 &&
            ($(this).val().charAt($(this).val().length - 3) === "." || $(this).val().charAt($(this).val().length - 4) === ".")) {
            $(this).parents('.b-modal').addClass('correct-email');
        } else {
            $(this).parents('.b-modal').removeClass('correct-email');
        }
    });

    $(document).on('keyup', '.js-name', function() {
        if ($(this).val() != "") {
            $(this).parents('.b-modal').addClass('correct-name');
        } else {
            $(this).parents('.b-modal').removeClass('correct-name');
        }
    });

    $('body').on('click', function(e) {
        if (!((e.target).closest('.js-subscribe-email')) && !((e.target).closest('.js-subscribe-name'))) { 
            $('.js-modal-subscribe').removeClass('correct-email');
            $('.js-modal-subscribe').removeClass('correct-name');
        } else if (!((e.target).closest('.js-subscribe-email'))) {
            $('.js-modal-subscribe').removeClass('correct-email');
        } else if (!((e.target).closest('.js-subscribe-name'))) {
            $('.js-modal-subscribe').removeClass('correct-name');
        }
    });

    $(document).on('click', '.js-subscribe-email', function() {
        $(this).parents('.b-modal').addClass('correct-email');
    });

    $(document).on('click', '.js-subscribe-name', function() {
        $(this).parents('.b-modal').addClass('correct-name');
    });

    $(document).on('click', '.js-signin-button', function(e) {
        if ($(this).parents('.b-modal').hasClass('correct-email')) {
            $('.b-modal').hide();
            $('.b-modal--auth').removeClass('wrong');
        } else {
            $(this).parents('.b-modal').addClass('wrong');
        }
    });

    $(document).on('click', '.js-signup-button', function(e) {
        if (document.getElementById("password").value !== document.getElementById("confirmPassword").value) {
            $('.b-modal--reg').addClass('wrong');
            $('.b-modal--reg').find('.b-modal__wrong').text('The password confirmation does not match.');
        } else if (document.getElementById("password").value.length < 6) {
            $('.b-modal--reg').addClass('wrong');
            $('.b-modal--reg .b-modal__row--password').find('.b-modal__wrong').text('The password must be at least 6 characters.');
        } else {
            $('.b-modal--reg').removeClass('wrong');
            if (document.getElementById("password").value != "" && document.getElementById("confirmPassword").value != "") {
                $('.b-modal').hide();
            }
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/general/signlogin.js